/** @format */

import React, { useState } from "react";
import { BreadCrumb } from "../../../components";
import moment from "moment";
import "moment/locale/id";
import type { RangePickerProps } from "antd/es/date-picker";
import { addFormData, uuidv4 } from "../../../utils/helper";
import {
  Table,
  Select,
  Space,
  Input,
  Button,
  Modal,
  Form,
  Tag,
  DatePicker,
  InputNumber,
  Checkbox,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import InputSearch from "../../../components/InputSearch";
import {
  ButtonTableDelete,
  ButtonTableEdit,
  ButtonTambah,
} from "../../../components/Button";
import notifAlert from "../../../components/NotifAlert";

import {
  deleteTanggalPengajuanBOS,
  editTanggalPengajuanBOS,
  postTanggalPengajuanBOS,
} from "../../../services/v2/planningservice/rencanapengajuanbos";
import { setBos } from "../../../redux/actions/bosAction";
import { getPlanningAll } from "../../../services/v2/planningservice";
import { UploadOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { getNamePenerimaBOS } from "../../../utils/helper/helperBos";

const { RangePicker } = DatePicker;

const TanggalPengajuanBOS = () => {
  const route = useHistory();
  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    { path: "/", breadcrumbName: "Pengaturan" },
    { path: "/", breadcrumbName: "Tanggal Pengajuan BOS" },
  ];
  const dispatch = useDispatch();
  const store = useSelector((state: any) => state.store);
  const auths = useSelector((state: any) => state.auth);
  const bos = useSelector((state: any) => state.bos);
  const [search, setSearch] = useState<any>(null);
  const [form] = Form.useForm();
  const [id, setID] = useState("");
  const [title, setTitle] = useState<any>(null);
  const [loading, setLoading] = useState<any>(false);
  const tmpJadwalPengajuan = bos.jadwalPengajuanBos || [];
  const tmpSumberDana = store.sumberDana || [];
  const tmpListPenerima = getNamePenerimaBOS() || [];

  const auth = auths.data || [];

  const [openModal, setOpenModal] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  let dataTable = search
    ? tmpJadwalPengajuan.filter((item: any) => {
        const val = search.toLowerCase();
        return (
          (item.sumberdana !== null &&
            (item.sumberdana || "").toLowerCase().includes(val)) ||
          (item.keterangan !== null &&
            (item.keterangan || "").toLowerCase().includes(val))
        );
      })
    : tmpJadwalPengajuan;

  let totalDataTable = dataTable.length;
  /**
   * Filter Pagination
   */
  dataTable = dataTable.filter((v, i) => {
    let start = pageSize * (page - 1);
    let end = start + pageSize;

    return i >= start && i < end;
  });

  const range = (start: number, end: number) => {
    const result: any = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    if (!current) return true;

    const isInEnabledRange = tmpJadwalPengajuan
      .filter((item) => item.id !== id)
      .some((range) => {
        const start = moment(range.start_date, "YYYY-MM-DD");
        const end = moment(range.end_date_pengajuan, "YYYY-MM-DD");
        return (
          current.isSameOrAfter(start, "day") &&
          current.isSameOrBefore(end, "day")
        );
      });

    return isInEnabledRange;
  };

  const disabledRangeTime: RangePickerProps["disabledTime"] = (_, type) => {
    if (type === "start") {
      return {
        // disabledHours: () => range(0, 60).splice(0, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    }
    return {
      disabledHours: () => range(0, 60).splice(20, 0),
      disabledMinutes: () => range(0, 31),
      disabledSeconds: () => [55, 56],
    };
  };

  const getData = async () => {
    try {
      const jadwalPengajuanBos = await getPlanningAll("all-jadwal-pengajuan", {
        tahun: auth.isTahun,
      });
      dispatch(setBos({ jadwalPengajuanBos }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (record: any) => {
    setTitle("Edit");
    setOpenModal(true);
    setID(record.id);
    form.setFieldsValue({
      sumberDana: record.sumberdana,
      tanggal: [moment(record.start_date), moment(record.end_date_pengajuan)],
      tanggalVerifikasi: moment(record.end_date_verifikator),
      keterangan: record.keterangan,
      batch: record.batch,
      jenisPenerima: record?.jenisPenerima || [],
    });
  };

  const handleDelete = async (record: any) => {
    try {
      await deleteTanggalPengajuanBOS(record.id);

      notifAlert({
        type: "success",
        description: "Tanggal tahapan berhasil selesai",
      });
      getData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleTambah = () => {
    setTitle("Tambah");
    setOpenModal(true);
    setID(uuidv4());
    form.setFieldsValue({
      kodeJenisTahapan: null,
      tanggal: null,
      keterangan: null,
    });
  };

  const handleSave = async (values: any) => {
    setLoading(true);

    let payload: any = {
      id: id,
      sumberDana: values.sumberDana,
      keterangan: values.keterangan || "",
      tahun: auth.isTahun,
      startDate: moment(values.tanggal[0]).format("YYYY-MM-DDTHH:mm"),
      endDatePengajuan: moment(values.tanggal[1]).format("YYYY-MM-DDTHH:mm"),
      endDateVerifikator: moment(values.tanggalVerifikasi).format(
        "YYYY-MM-DDTHH:mm",
      ),
      jenisPenerima: values?.jenisPenerima || [],
      batch: values.batch,
    };

    if (title === "Tambah") {
      try {
        await postTanggalPengajuanBOS(addFormData(payload));
        notifAlert({
          type: "success",
          description: "Tanggal pengajuan berhasil di simpan",
        });
        getData();
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await editTanggalPengajuanBOS(addFormData(payload), id);
        notifAlert({
          type: "success",
          description: "Tanggal pengajuan berhasil di simpan",
        });
        getData();
      } catch (error) {
        console.log(error);
      }
    }

    handleReset();
    setLoading(false);
  };

  const handleDokumen = (record: any) => {
    route.push({
      pathname: "tanggal-pengajuan-bos/dokumen-pengajuan/",
      state: {
        page: page,
        pageSize: pageSize,
        ...record,
      },
    });
  };

  const columns: any = [
    {
      title: "Sumber Dana",
      dataIndex: "sumberdana",
      key: "sumberdana",
      render: (sumberdana) => {
        let namaSumberDana =
          tmpSumberDana.find((item) => item.kode === sumberdana) || null;
        return namaSumberDana?.nama || "";
      },
    },
    {
      title: "Batch",
      dataIndex: "batch",
      key: "batch",
      className: "capitalize",
    },
    {
      title: "Tanggal Pengajuan",
      children: [
        {
          title: "Mulai",
          dataIndex: "start_date",
          key: "start_date",
          render: (start_date) =>
            moment(start_date).format("dddd,DD MMM YYYY HH:mm:ss"),
        },
        {
          title: "Akhir",
          dataIndex: "end_date_pengajuan",
          key: "end_date_pengajuan",
          render: (end_date_pengajuan) =>
            moment(end_date_pengajuan).format("dddd,DD MMM YYYY HH:mm:ss"),
        },
      ],
    },

    {
      title: "Tanggal Akhir Verifikasi",
      dataIndex: "end_date_verifikator",
      key: "end_date_verifikator",
      render: (end_date_verifikator) =>
        moment(end_date_verifikator).format("dddd,DD MMM YYYY HH:mm:ss"),
    },
    {
      title: "Jenis Penerima",
      dataIndex: "jenisPenerima",
      key: "jenisPenerima",
      render: (jenisPenerima) => {
        return (
          jenisPenerima?.length &&
          jenisPenerima.map((item) => {
            let tmpJP: any =
              tmpListPenerima.find((items) => items.kode.toString() === item) ||
              null;
            return <Tag>{tmpJP?.name}</Tag>;
          })
        );
      },
    },
    {
      title: "Keterangan",
      dataIndex: "keterangan",
      key: "keterangan",
    },
    {
      title: "Dokumen",
      key: "dokumen",
      render: (record) => (
        <Button
          // disabled={
          //   spesialBOSPengajuan().includes(auth?.madrasah?.nsm)
          //     ? false
          //     : record?.kode_sumber_dana === "apbn_bos_semester_2"
          //     ? false
          //     : true
          // }
          icon={<UploadOutlined />}
          onClick={() => handleDokumen(record)}>
          Dokumen Pengajuan
        </Button>
      ),
    },
    {
      title: "Aksi",
      key: "aksi",
      render: (record: any) => (
        <Space size="small">
          <ButtonTableEdit onClick={() => handleEdit(record)} />
          <ButtonTableDelete
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                onOk() {
                  return handleDelete(record);
                },
                onCancel() {},
                okText: "Selesai",
                cancelText: "Batal",
                okType: "danger",
              });
            }}
          />
        </Space>
      ),
    },
  ];

  const handleReset = () => {
    form.resetFields();
    setOpenModal(false);
  };

  return (
    <>
      <BreadCrumb routes={itemBreadcrumb} title="Tanggal Pengajuan BOS" />
      <div className="m-5 p-5 bg-white shadow-md rounded">
        <div className="mb-4 flex justify-end">
          <div className="mr-4">
            <ButtonTambah onClick={handleTambah} />
          </div>
          <InputSearch
            className="w-3/4"
            onChange={(e: any) => setSearch(e.currentTarget.value)}
          />
        </div>

        <div className="w-full">
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            tableLayout="auto"
            dataSource={dataTable}
            bordered
            pagination={{
              total: totalDataTable,
              position: ["bottomRight"],
              defaultPageSize: pageSize,
              defaultCurrent: page,
              showTotal: (total) => `Total ${total} items`,
              onChange(page, pageSize) {
                setPage(page);
                setPageSize(pageSize);
              },
            }}
          />
        </div>
      </div>
      <Modal
        open={openModal}
        width={800}
        title={`${title} Pengajuan BOS`}
        onCancel={handleReset}
        footer={[
          <Button key="back" onClick={handleReset}>
            Batal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}>
            Simpan
          </Button>,
        ]}>
        <Form
          form={form}
          key="formPengajuanBos"
          name="formPengajuanBos"
          layout="vertical"
          onFinish={handleSave}>
          <div className="flex flex-row md:flex-col gap-4">
            <div className="flex-1">
              <Form.Item
                label="Sumber Dana"
                name="sumberDana"
                rules={[
                  {
                    required: true,
                    message: "Sumber Dana tidak boleh kosong!",
                  },
                ]}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Pilih Sumber Dana">
                  {tmpSumberDana?.length &&
                    tmpSumberDana
                      .filter(
                        (item: any) =>
                          item.bos === "1" && item.madrasah_s === "1",
                      )
                      .map((e: any, i: any) => {
                        return (
                          <Select.Option key={`role${i}`} value={e.kode}>
                            {e.nama}
                          </Select.Option>
                        );
                      })}
                </Select>
              </Form.Item>
            </div>
            <div className="flex-1">
              <Form.Item
                label="Batch"
                name="batch"
                rules={[
                  {
                    required: true,
                    message: "Batch tidak boleh kosong!",
                  },
                ]}>
                <InputNumber type="number" min={1} placeholder="Batch" />
              </Form.Item>
            </div>
          </div>
          <div className="flex flex-row md:flex-col gap-4">
            <div className="flex-1">
              <Form.Item
                label="Tanggal Pengajuan Mulai dan Akhir"
                name="tanggal"
                rules={[
                  {
                    required: true,
                    message:
                      "Tanggal Mulai dan Tanggal Akhir tidak boleh kosong!",
                  },
                ]}>
                <RangePicker
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                  disabledTime={disabledRangeTime}
                  placeholder={["Pilih Tanggal Mulai", "Pilih Tanggal Selesai"]}
                  showTime={{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment("00:00:00", "HH:mm:ss"),
                      moment("11:59:59", "HH:mm:ss"),
                    ],
                  }}
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </Form.Item>
            </div>
            <div className="flex-1">
              <Form.Item
                label="Tanggal Akhir Verifikasi"
                name="tanggalVerifikasi"
                rules={[
                  {
                    required: true,
                    message: "Tanggal Akhir Verifikasi tidak boleh kosong!",
                  },
                ]}>
                <DatePicker placeholder="Tanggal Akhir Verifikasi" showTime />
              </Form.Item>
            </div>
          </div>
          <Form.Item label="Jenis Penerima" name="jenisPenerima" required>
            <Checkbox.Group>
              <div className="grid grid-cols-1 gap-2">
                {tmpListPenerima.map((item: any) => {
                  return (
                    <div>
                      <Checkbox
                        value={item.kode.toString()}
                        style={{ lineHeight: "32px" }}>
                        {item.name}
                      </Checkbox>
                    </div>
                  );
                })}
              </div>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item label="Keterangan" name="keterangan">
            <Input.TextArea placeholder="Keterangan" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default TanggalPengajuanBOS;
